const fakeNames = {
  MALE: ['Andrea', 'Carlo', 'Davide', 'Edoardo', 'Giovanni', 'Luca', 'Luigi', 'Mario', 'Michele'],
  FEMALE: ['Anna', 'Carla', 'Daniela', 'Elena', 'Giovanna', 'Lucia', 'Luisa', 'Maria', 'Michela'],
};

const getFakeName = (gender, alreadyUsed = []) => {
  const names = (fakeNames[gender] || fakeNames['MALE']).filter(
    (name) => !alreadyUsed.includes(name)
  );
  return names[Math.floor(Math.random() * names.length)];
};

export const fakePassenger = (
  travelerIndex,
  namesToAvoid = [],
  withMiddleName = false,
  withSecondLastName = false
) => {
  const gender = travelerIndex % 2 === 0 ? 'MALE' : 'FEMALE';
  const firstname = getFakeName(gender, namesToAvoid);
  const middlename = withMiddleName ? getFakeName(gender, [...namesToAvoid, firstname]) : '';

  return {
    firstname,
    middlename,
    lastname: 'Rossi',
    second_lastname: withSecondLastName ? 'Verdi' : '',
    gender,
  };
};
